"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaFilterController = function () {
  function MediaFilterController($scope, FilterService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, MediaFilterController);
    this.filterService = FilterService;

    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
  }

  (0, _createClass3.default)(MediaFilterController, [{
    key: "$onInit",
    value: function $onInit() {
      this.setFilterOptions();
    }
  }, {
    key: "setFilterOptions",
    value: function setFilterOptions() {
      this.filterOptions = this.filterService.getMediaFilterOptions();
    }
  }, {
    key: "onFilterChagne",
    value: function onFilterChagne(newval, oldval) {
      this.filterService.generateFilterExpression(this.filterOptions);
      this.applyFilters();
    }
  }]);
  return MediaFilterController;
}();

exports.default = MediaFilterController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/media-filter/media-filter.controller.js
 **/